// Shared styling for list rows, so the MuiListItemButton theme override and
// plain read-only rows cannot drift apart.

// Vertical padding of a list row. Read-only rows have to repeat it explicitly to
// line up with ListItemButton rows, which get it from the theme override.
export const listItemRowPaddingY = '10px';

// The accent applied to a hovered or selected list row. In dark mode the "15"
// suffix turns the hex colour into an 8-digit value, i.e. the same colour at
// roughly 8% opacity.
export const listItemAccent = (theme) =>
  theme.palette.mode === 'dark'
    ? { backgroundColor: `${theme.palette.secondary.main}15`, color: theme.palette.secondary.main }
    : { backgroundColor: theme.palette.secondary.light, color: theme.palette.secondary.dark };

// sx for a read-only list row, e.g. a label/value pair in an info card.
//
// Use this instead of ListItemButton when the row has no onClick: ButtonBase
// sets user-select: none, which stops the user copying the value, and makes the
// row a focusable button that does nothing. This keeps the hover tint as a
// reading aid while leaving the text selectable.
export const readOnlyRowSx = (theme) => ({
  py: listItemRowPaddingY,
  '&:hover': listItemAccent(theme)
});
